import { responsiveStyle } from '@synoptic/ui-kit/responsive/responsive-style.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, fontWeight, space } from '@synoptic/ui-kit/tokens.ts';
import { typography } from '@synoptic/ui-kit/typography.js';
import { globalStyle, style } from '@vanilla-extract/css';
import { feedFloatingAction } from '@/components/feed/feed-scroller-with-floating-header.css';

export const emptyState = style([
  {
    margin: `${space.s60}px 0`,
  },
]);

export const streamPostsWrapper = style({});

globalStyle(`${streamPostsWrapper} .${feedFloatingAction}`, {
  top: space.s70,
});

export const lockIcon = style([
  {
    color: themeVars.color.icon.secondary,
  },
]);

export const lockedStreamCtaPost = style({
  position: 'relative',
  selectors: {
    '&:is(&)': {
      boxShadow: 'none',
      outline: 'none',
    },
  },
});

export const lockedStreamCtaPostHint = style([
  {
    ...typography.bodyMd,
    color: themeVars.color.text.disabled,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    textAlign: 'center',
    gap: space.s4,
    marginTop: space.s10,
  },
]);

export const lockedStreamCtaPostAction = style([
  {
    ...typography.titleLg,
    fontWeight: fontWeight.medium,
    display: 'flex',
    flexDirection: 'column',
    position: 'absolute',
    alignItems: 'center',
    borderRadius: borderRadius.r16,
    justifyContent: 'center',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    padding: space.s16,
    textAlign: 'center',
    gap: space.s20,
    backdropFilter: 'blur(10px)',
    overflow: 'hidden',
  },
]);

export const lockedCustomStreamCtaPostAction = style([
  lockedStreamCtaPostAction,
  {
    selectors: {
      '&:is(&)': {
        ...typography.titleMd,
      },
    },
  },
]);

globalStyle(`${lockedStreamCtaPost} :where(svg)`, {
  color: themeVars.color.icon.disabled,
});

export const connectionStatus = style([
  responsiveStyle({
    mobile: {
      marginRight: 0,
    },
    tablet: {
      marginRight: 'auto',
    },
  }),
]);

export const hintContainer = style([
  connectionStatus,
  {
    color: themeVars.container.foreground.secondary,
  },
]);

export const streamPostsSearch = style(
  responsiveStyle({
    mobile: {
      width: '100%',
      maxWidth: '300px',
    },
    tablet: {
      width: 'auto',
    },
  }),
);
